// extracted by mini-css-extract-plugin
export var option = "_kh-0";
export var optionCard = "_kh-f";
export var optionContent = "_kh-g";
export var optionIcon = "_kh-i";
export var optionIconBox = "_kh-h";
export var optionLabel = "_kh-j";
export var optionPill = "_kh-m";
export var optionPillBadge = "_kh-p";
export var optionPillIcon = "_kh-n";
export var optionPillLabel = "_kh-o";
export var optionRadio = "_kh-k";
export var optionRadioInner = "_kh-l";
export var optionReveal = "_kh-2";
export var optionRevealDelay0 = "_kh-3";
export var optionRevealDelay1 = "_kh-4";
export var optionRevealDelay10 = "_kh-d";
export var optionRevealDelay11 = "_kh-e";
export var optionRevealDelay2 = "_kh-5";
export var optionRevealDelay3 = "_kh-6";
export var optionRevealDelay4 = "_kh-7";
export var optionRevealDelay5 = "_kh-8";
export var optionRevealDelay6 = "_kh-9";
export var optionRevealDelay7 = "_kh-a";
export var optionRevealDelay8 = "_kh-b";
export var optionRevealDelay9 = "_kh-c";
export var optionSelected = "_kh-1";